import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

import {
  Button,
  Modal,
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
  OutlinedInput,
  InputLabel,
  FormControl,
  Checkbox,
} from "@mui/material";
import DetailsPart from "./DetailsPartPayment";

export default function PartPaymentModal({
  open,
  handleClose,
  bill,
  setBill,
  setOpen,
  addAllAmount,
}) {
  const [partModal, setPartModal] = React.useState(false);
  const handleClosepart = () => setPartModal(false);
  const totalAmount = addAllAmount().payableAmount;
  const [detailsData, setDetailsData] = React.useState({});
  const [currentMode, setCurrentMode] = React.useState(null);
  const [selectedModes, setSelectedModes] = React.useState([]);
  const [amounts, setAmounts] = React.useState({});
  const [payments, setPayments] = React.useState({
    upi: false,
    cash: false,
    card: false,
    credit: false,
    cheque: false,
    netBanking: false,
    pcr: false,
    wallet: false,
    other: false,
  });
  const handleModeChange = (mode) => {
    let updatedModes;

    if (selectedModes.includes(mode)) {
      // Remove mode
      updatedModes = selectedModes.filter((m) => m !== mode);

      const updatedAmounts = { ...amounts };
      delete updatedAmounts[mode];

      setSelectedModes(updatedModes);
      setAmounts(updatedAmounts);
    } else {
      // Add mode
      updatedModes = [...selectedModes, mode];

      // Calculate remaining
      const currentTotal = Object.values(amounts).reduce(
        (sum, val) => sum + val,
        0,
      );

      const remaining = totalAmount - currentTotal;

      setSelectedModes(updatedModes);
      setAmounts({
        ...amounts,
        [mode]: remaining > 0 ? remaining : 0,
      });
    }
  };
  const handleAmountChange = (mode, value) => {
    const numericValue = parseFloat(value) || 0;

    const updatedAmounts = {
      ...amounts,
      [mode]: numericValue,
    };

    const otherModes = selectedModes.filter((m) => m !== mode);

    const remaining =
      totalAmount -
      Object.values(updatedAmounts).reduce((sum, val) => sum + val, 0);

    // If only 2 modes → auto adjust second
    if (otherModes.length === 1) {
      updatedAmounts[otherModes[0]] = remaining > 0 ? remaining : 0;
    }

    setAmounts(updatedAmounts);
  };

  // const totalEntered = Object.values(amounts).reduce(
  //   (sum, val) => sum + val,
  //   0,
  // );

  // if (totalEntered !== totalAmount) {
  //   alert("Total part payment must match payable amount");
  //   return;
  // }
  // React.useEffect(() => {
  //   if (bill?.counterSalesPartPayment?.length > 0) {
  //     const modes = bill.counterSalesPartPayment.map(
  //       (item) => item.paymentMode,
  //     );

  //     const amountObj = {};
  //     bill.counterSalesPartPayment.forEach((item) => {
  //       amountObj[item.paymentMode] = item.amount;
  //     });

  //     setSelectedModes(modes);
  //     setAmounts(amountObj);
  //   }
  // }, [bill, open]);

  React.useEffect(() => {
    if (bill?.partPayments?.length > 0) {
      const modes = bill.partPayments.map(
        (item) => item.paymentMode, // normalize
      );

      const amountObj = {};
      const detailsObj = {};
      bill.partPayments.forEach((item) => {
        amountObj[item.paymentMode] = item.amount;
        detailsObj[item.paymentMode] = item.details || "";
      });

      setSelectedModes(modes);
      setAmounts(amountObj);
      setDetailsData(detailsObj);
    }
  }, [bill, open]);
  const handleSave = () => {
    const counterSalesPartPayment = selectedModes.map((mode) => ({
      amount: amounts[mode],
      paymentMode: mode,
      details: detailsData[mode] || "",
    }));

    setBill((prev) => ({
      ...prev,
      // paymentMode: "Part Payment",
      counterSalesPartPayment,
    }));

    console.log(counterSalesPartPayment);

    setOpen(false);
  };
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            background: "white",
            width: { xs: "95%", sm: "40%", md: "40%", lg: "50%", xl: "50%" },

            position: "absolute",
            left: { xs: "2%", sm: "35%", md: "35%", lg: "25%", xl: "25%" },

            top: "20%",
          }}
        >
          <Box sx={{ backgroundColor: "#C0BFFF", mb: 2 }}>
            <CloseIcon
              sx={{
                fontSize: "28px",
                float: "right",
                m: "10px",
                cursor: "pointer",
              }}
              onClick={() => {
                setOpen(false);
              }}
            />
            <Typography
              sx={{
                p: "10px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
              color="primary"
            >
              Total Amount
            </Typography>
          </Box>
          <Grid
            sx={{
              p: "10px",
            }}
          >
            <Grid container>
              <Grid container mb={2} spacing={2}>
                <Grid item xs={4}>
                  Payment Mode
                </Grid>
                <Grid item xs={4}>
                  Amount
                </Grid>
                <Grid item xs={4}>
                  Details
                </Grid>
              </Grid>
              <Grid container>
                <Grid container spacing={1} mb={1}>
                  <Grid item xs={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedModes.includes("UPI")}
                          onChange={() => handleModeChange("UPI")}
                          size="small"
                        />
                      }
                      label="UPI"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      value={amounts["UPI"] || ""}
                      disabled={!selectedModes.includes("UPI")}
                      onChange={(e) =>
                        handleAmountChange("UPI", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      fullWidth
                      sx={{
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: 700,
                        color: "#01008BA8",
                      }}
                      onClick={() => {
                        setCurrentMode("UPI"); // change according to mode
                        setPartModal(true);
                      }}
                    >
                      Edit
                    </Typography>
                  </Grid>
                </Grid>
                {/* . */}
                <Grid container spacing={1} mb={1}>
                  <Grid item xs={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedModes.includes("Cash")}
                          onChange={() => handleModeChange("Cash")}
                          size="small"
                        />
                      }
                      label="Cash"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      value={amounts["Cash"] || ""}
                      disabled={!selectedModes.includes("Cash")}
                      onChange={(e) =>
                        handleAmountChange("Cash", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      fullWidth
                      sx={{
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: 700,
                        color: "#01008BA8",
                      }}
                      onClick={() => {
                        setCurrentMode("Cash"); // change according to mode
                        setPartModal(true);
                      }}
                    >
                      Edit
                    </Typography>
                  </Grid>
                </Grid>
                {/* . */}
                <Grid container spacing={1} mb={1}>
                  <Grid item xs={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedModes.includes("CardPay")}
                          onChange={() => handleModeChange("CardPay")}
                          size="small"
                        />
                      }
                      label="Card Payment"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      value={amounts["CardPay"] || ""}
                      disabled={!selectedModes.includes("CardPay")}
                      onChange={(e) =>
                        handleAmountChange("CardPay", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      fullWidth
                      sx={{
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: 700,
                        color: "#01008BA8",
                      }}
                      onClick={() => {
                        setCurrentMode("CardPay"); // change according to mode
                        setPartModal(true);
                      }}
                    >
                      Edit
                    </Typography>
                  </Grid>
                </Grid>
                {/* . */}
                <Grid container spacing={1} mb={1}>
                  <Grid item xs={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedModes.includes("Credit")}
                          onChange={() => handleModeChange("Credit")}
                          size="small"
                        />
                      }
                      label="Credit(balance)"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      value={amounts["Credit"] || ""}
                      disabled={!selectedModes.includes("Credit")}
                      onChange={(e) =>
                        handleAmountChange("Credit", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      fullWidth
                      sx={{
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: 700,
                        color: "#01008BA8",
                      }}
                      onClick={() => {
                        setCurrentMode("Credit"); // change according to mode
                        setPartModal(true);
                      }}
                    >
                      Edit
                    </Typography>
                  </Grid>
                </Grid>
                {/* . */}
                <Grid container spacing={1} mb={1}>
                  <Grid item xs={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedModes.includes("Cheque")}
                          onChange={() => handleModeChange("Cheque")}
                          size="small"
                        />
                      }
                      label="Cheque"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      value={amounts["Cheque"] || ""}
                      disabled={!selectedModes.includes("Cheque")}
                      onChange={(e) =>
                        handleAmountChange("Cheque", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      fullWidth
                      sx={{
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: 700,
                        color: "#01008BA8",
                      }}
                      onClick={() => {
                        setCurrentMode("Cheque"); // change according to mode
                        setPartModal(true);
                      }}
                    >
                      Edit
                    </Typography>
                  </Grid>
                </Grid>
                {/* . */}
                <Grid container spacing={1} mb={1}>
                  <Grid item xs={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedModes.includes("NetBanking")}
                          onChange={() => handleModeChange("NetBanking")}
                          size="small"
                        />
                      }
                      label="Net Banking"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      value={amounts["NetBanking"] || ""}
                      disabled={!selectedModes.includes("NetBanking")}
                      onChange={(e) =>
                        handleAmountChange("NetBanking", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      fullWidth
                      sx={{
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: 700,
                        color: "#01008BA8",
                      }}
                      onClick={() => {
                        setCurrentMode("NetBanking"); // change according to mode
                        setPartModal(true);
                      }}
                    >
                      Edit
                    </Typography>
                  </Grid>
                </Grid>
                {/* . */}
                <Grid container spacing={1} mb={1}>
                  <Grid item xs={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedModes.includes("PCR")}
                          onChange={() => handleModeChange("PCR")}
                          size="small"
                        />
                      }
                      label="PCR"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      value={amounts["PCR"] || ""}
                      disabled={!selectedModes.includes("PCR")}
                      onChange={(e) =>
                        handleAmountChange("PCR", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      fullWidth
                      sx={{
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: 700,
                        color: "#01008BA8",
                      }}
                      onClick={() => {
                        setCurrentMode("PCR"); // change according to mode
                        setPartModal(true);
                      }}
                    >
                      Edit
                    </Typography>
                  </Grid>
                </Grid>
                {/* . */}
                <Grid container spacing={1} mb={1}>
                  <Grid item xs={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedModes.includes("Wallet")}
                          onChange={() => handleModeChange("Wallet")}
                          size="small"
                        />
                      }
                      label="Wallet"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      value={amounts["Wallet"] || ""}
                      disabled={!selectedModes.includes("Wallet")}
                      onChange={(e) =>
                        handleAmountChange("Wallet", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      fullWidth
                      sx={{
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: 700,
                        color: "#01008BA8",
                      }}
                      onClick={() => {
                        setCurrentMode("Wallet"); // change according to mode
                        setPartModal(true);
                      }}
                    >
                      Edit
                    </Typography>
                  </Grid>
                </Grid>
                {/* . */}
                <Grid container spacing={1} mb={1}>
                  <Grid item xs={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedModes.includes("OtherPay")}
                          onChange={() => handleModeChange("OtherPay")}
                          size="small"
                        />
                      }
                      label="Other Payment Mode"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      value={amounts["OtherPay"] || ""}
                      disabled={!selectedModes.includes("OtherPay")}
                      onChange={(e) =>
                        handleAmountChange("OtherPay", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      fullWidth
                      sx={{
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: 700,
                        color: "#01008BA8",
                      }}
                      onClick={() => {
                        setCurrentMode("OtherPay"); // change according to mode
                        setPartModal(true);
                      }}
                    >
                      Edit
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Button
              variant="contained"
              sx={{
                width: "100%",
                mt: "10px",
              }}
              onClick={() => {
                setOpen(false);
                //   setBill(data);
                handleSave();
              }}
            >
              {" "}
              Save
            </Button>
          </Grid>
        </Box>
      </Modal>
      <DetailsPart
        open={partModal}
        handleClose={handleClosepart}
        setOpen={setPartModal}
        mode={currentMode}
        detailsData={detailsData}
        setDetailsData={setDetailsData}
      />
    </>
  );
}
